let searchApi = {
  name: "商品搜索接口",
  updateTime: "2020-05-30 10:00:00",
  methods: 'post',
  url: 'ygw.api.search.thirdparty',
  request: [{
    params: '+context',
    type: "Object",
    required: false,
    length: '',
    description: {
      text: '搜索查询参数',
      value: []
    },
    example: ''
  }, {
    params: '└searchWord',
    type: "number",
    required: false,
    length: '32',
    description: {
      text: '搜索词',
      value: []
    },
    example: '0603'
  }, {
    params: '+page',
    type: "Object",
    required: true,
    length: '',
    description: {
      text: '',
      value: []
    },
    example: ''
  }, {
    params: '└currPage',
    type: "number",
    required: false,
    length: '32',
    description: {
      text: '当前要请求的页码',
      value: ['不能小于1', '小于1或者不传时默认为1']
    },
    example: '2'
  }, {
    params: '└pageSize',
    type: "number",
    required: false,
    length: '32',
    description: {
      text: '每页的条目数',
      value: ['不能小于1', '小于1默认为10']
    },
    example: '10'
  }],
  reseponse: [{
    params: 'pageNo',
    type: "number",
    required: true,
    length: '32',
    description: {
      text: '当 前 页 数',
      value: []
    },
    example: '1'
  }, {
    params: 'pageSize',
    type: "number",
    required: true,
    length: '32',
    description: {
      text: '总页数',
      value: []
    },
    example: '10'
  }, {
    params: '+list',
    type: "Object[]",
    required: true,
    length: '',
    description: {
      text: '查询出来的物料信息列表',
      value: []
    },
    example: ''
  }, {
    params: '└goodsName',
    type: "string",
    required: true,
    length: '',
    description: {
      text: '物 料 名 称',
      value: []
    },
    example: '贴片发光二极管 <em class="highLight">06</em><em class="highLight">0</em><em class="highLight">3</em> 白色'
  }, {
    params: '└stock',
    type: "number",
    required: true,
    length: '64',
    description: {
      text: '商品库存数量',
      value: []
    },
    example: '100000'
  }, {
    params: '└minPurchase',
    type: "number",
    required: true,
    length: '32',
    description: {
      text: '最小起购数',
      value: []
    },
    example: '50'
  }, {
    params: '└ priceList',
    type: "object[]",
    required: true,
    length: '',
    description: {
      text: '价格阶梯',
      value: []
    },
    example: ''
  }, {
    params: '└└qtyStart',
    type: "Number",
    required: true,
    length: '32',
    description: {
      text: '阶梯下限',
      value: []
    },
    example: '50'
  }, {
    params: '└└qtyEnd',
    type: "number",
    required: true,
    length: '32',
    description: {
      text: '阶梯上线',
      value: []
    },
    example: '950'
  }, {
    params: '└└price',
    type: "object",
    required: true,
    length: '',
    description: {
      text: '当前阶梯价格',
      value: []
    },
    example: '0.0012'
  }, {
    params: '└└showInfo',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '阶梯信息',
      value: []
    },
    example: '20-980pcs'
  }, {
    params: '└packingQty',
    type: "Number",
    required: true,
    length: '',
    description: {
      text: '最小包装数',
      value: []
    },
    example: '5000'
  }, {
    params: '└brandName',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '品牌名称',
      value: []
    },
    example: '美隆'
  }, {
    params: '└goodsCode',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '油柑编码',
      value: []
    },
    example: '0XXXX00000'
  }, {
    params: '└factoryCode',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '原厂编码',
      value: []
    },
    example: 'FC-DA1'
  }],
  code: {
    sign: "94c0d23036d9ef73c551c8c49497d802",
    appId: "9527",
    method: "ygw.api.order.create",
    params: JSON.stringify({
      context: {
        searchWord: "美隆"
      },
      page: {
        currPage: 20,
        pageSize: 100
      }
    })
  }
}

export default searchApi;